import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from '@/context/AuthContext';

import Landing from '@/pages/Landing';
import Checker from '@/pages/Checker';
import Results from '@/pages/Results';

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <Toaster position="top-right" richColors />
                    <Routes>
                        <Route path="/" element={<Landing />} />
                        <Route path="/check" element={<Checker />} />
                        <Route path="/results/:id" element={<Results />} />
                    </Routes>
                </BrowserRouter>
            </AuthProvider>
        </div>
    );
}

export default App;
